import { PageType } from "../../../config/page.types";
import PlaceholderView from "../../PlaceholderView";

const DataInsightsHotspots = () => {
	return <PlaceholderView pageType={PageType.DataInsightsHotspots} text="Hotspots" />;
};

export default DataInsightsHotspots;
